import store from '@/store';
import hasClubhousePermission, { hasPermission } from '@/utils/hasClubhousePermission';

export default async (to, from, next) => {
  const clubhouse = store.getters['users/getClubhouse'];
  const hasSeasons = store.getters['users/hasSeasons'];
  const { clubhouseID } = to.params;
  const { name } = to;

  //* Dashboard ID check - prevent undefined clubhouse ids
  if (name === 'clubhouseDashboard') {
    if (
      clubhouseID !== 'undefined' &&
      clubhouseID !== undefined &&
      typeof clubhouseID === 'string'
    ) {
      next();
      return;
    }
    next('/clubhouses');
    return;
  }

  //* New Route Guard Based on Clubmember Permissions ==============================

  if (clubhouseID === undefined) {
    return false;
  }

  // const userClubPermissions = store.getters['users/clubPermissions'];
  const clubPermissions = (await store.dispatch('users/clubPermissions')) ?? [];
  const requiredPermission = to?.meta?.requiresPermission ?? [];
  let clubhouseList = store.getters['clubhouses/list'];
  if (!clubhouseList.length) {
    clubhouseList = (await store.dispatch('clubhouses/list')) ?? [];
  }
  const userClubhouseID = clubhouse?.id?.toString();
  const clubhouseData =
    clubhouseList.find((club) => {
      return club?.id?.toString() === clubhouseID?.toString();
    }) ?? {};

  const clubhouseDataPermissions =
    clubPermissions?.find((data) => {
      return data?.club_uuid === clubhouseData?.uuid;
    }) ?? {};

  const isOwnerClub = clubhouse && userClubhouseID?.toString() === clubhouseID?.toString();

  const hasThePermission =
    hasPermission(clubhouseDataPermissions?.permissions, requiredPermission) ?? false;

  if (
    (requiredPermission?.length && (isOwnerClub || hasThePermission)) ||
    ((to.name === 'newSeason' || to.name === 'editSeason') && hasSeasons)
  ) {
    next();
    return;
  }

  //* ===================================================

  //* Edit/Announcement club verification. Prevent other clubhouses from
  //* editing items they aren't authorized to
  // if (clubhouse) {
  //   try {
  //     if (Number(clubhouseID) !== Number(clubhouse.id)) {
  //       next(`/clubhouse/${clubhouseID}/dashboard`);
  //       return;
  //     }
  //   } catch (error) {
  //     console.error('error:', error);
  //     next(); //* my clubhouse id matches route, authorized to access
  //     return;
  //   }
  // }
  // next(`/clubhouse/${clubhouseID}/dashboard`).catch((err) => {
  //   return console.log(err);
  // });

  if (clubhouse) {
    if (Number(clubhouseID) !== Number(clubhouse.id)) {
      next(`/clubhouse/${clubhouseID}/dashboard`);
      return;
    }
    next(); //* my clubhouse id matches the route, authorized to access
    return;
  }
  next(`/clubhouse/${clubhouseID}/dashboard`);
};
